var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userGuideUrl)?_c('a',{staticClass:"user-guide-btn cursor-pointer mr-3 flex items-center",attrs:{"href":_vm.userGuideUrl,"target":"_blank","rel":"noopener noreferrer","title":_vm.$t('UserGuide')}},[_c('feather-icon',{attrs:{"icon":"HelpCircleIcon","svg-classes":"h-7 w-7"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }